import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomerSelect from '@/components/Form/Shared/CustomerSelect'
import CustomerIcons from '@/icons/CustomerIcons'
import { Service } from '@/modules/Service/types'
import TicketService from '../../Forms/TicketService'
import ServiceSLAPreview from '../../Forms/ServiceSLAPreview'
import SectionHeader from '../section-header'
import { CreateTicketSectionProps, ServiceSLAData } from '../types'

interface CustomerServiceSectionProps extends CreateTicketSectionProps {
    onServiceChange: (
        service:
            | Partial<
                  Service & {
                      type: 'service'
                      label: string
                      value: number
                      cs_assignees?: number[]
                      sale_assignees?: number[]
                  }
              >
            | {
                  type: 'service_interesting'
                  label: string
                  value: string
                  cs_assignees?: number[]
                  sale_assignees?: number[]
              }
    ) => void
    onServiceSLALoaded: (slaData: ServiceSLAData) => void
}

const CustomerServiceSection: React.FC<CustomerServiceSectionProps> = ({
    control,
    watch,
    setValue,
    onServiceChange,
    onServiceSLALoaded,
}) => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()

    return (
        <div className="bg-white rounded-md p-4 border border-gray-100">
            <SectionHeader
                step={2}
                title={t('ticket-customer-info')}
                icon={<CustomerIcons className="w-4 h-4" />}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div data-tour="customer-select">
                    <CustomerSelect
                        defaultCustomerID={Number(
                            searchParams.get('customer_id')
                        )}
                        control={control}
                        name="customer_id"
                        showLabel
                        disabled={!!searchParams.get('customer_id')}
                    />
                </div>
                <div data-tour="service-select">
                    <TicketService
                        control={control}
                        customerID={watch('customer_id')}
                        onChangeService={onServiceChange}
                        journeyID={Number(
                            searchParams.get('customer_journey_id')
                        )}
                        ticketTypeGroup={watch('ticket_type_group')}
                        ticketTypeKey={watch('ticket_type_key')}
                        setValue={setValue}
                        autoSelectFirst
                    />
                </div>
            </div>
            {/* Service SLA Preview - show when service is selected */}
            {!!watch('service_id') && Number(watch('service_id')) > 0 && (
                <div className="mt-3" data-tour="service-sla-preview">
                    <ServiceSLAPreview
                        serviceId={Number(watch('service_id'))}
                        ticketTypeGroup={watch('ticket_type_group')}
                        ticketTypeKey={watch('ticket_type_key')}
                        ticketRequestedAt={watch('ticket_requested_at')}
                        onSLALoaded={onServiceSLALoaded}
                    />
                </div>
            )}
        </div>
    )
}

export default CustomerServiceSection
